// extracted by mini-css-extract-plugin
export default {"dialog":"dialog__e7EgP","dialog-content":"dialog-content__slw-x","dialogContent":"dialog-content__slw-x"};